import React from "react";
import {useTranslation} from "react-i18next";
import Tooltip from "./Tooltip.jsx";

export default function ReportingInfoTooltip({children, ariaLabel, position = "bottom", size = "md", className = ""}) {
    const {t} = useTranslation();

    return <Tooltip
        bg="dark"
        size={size}
        position={position}
        className={`inline-flex shrink-0 normal-case text-left font-normal ${className}`}
        triggerClassName="rounded-full p-0.5 text-slate-500 hover:text-violet-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400 dark:text-slate-400 dark:hover:text-violet-300 dark:focus-visible:outline-slate-500"
        ariaLabel={ariaLabel ?? t("reporting_lab.kpi.info_label", {defaultValue: "Vysvětlení metriky"})}
        trigger={<svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="8.25" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M10 9v5m0-8h.01" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
        </svg>}
    >
        <div className="text-xs leading-5 text-gray-200">{children}</div>
    </Tooltip>;
}
